import React, { useCallback } from "react";
import { useDispatch } from "react-redux";
import { useToggle } from "react-use";
import * as yup from "yup";
import { cashbackEditClient } from "./reducers/cashback-actions";
import { Stack } from "@mui/material";
import EntradaForm from "../../../components/entrada-form";
import { H6, Body1 } from "../../../components";

const STR = {
  title: "Atualizar Cliente",
  subtitle:
    "Atualize dados do cliente, como o nome ou telefone, caso não estejam corretos",
  labelNameClient: "Nome do Cliente",
  labelCellPhone: "Telefone",
  placeholderNameClient: "Digite o nome do cliente",
  placeholderCellPhone: "Digite o telefone do cliente",
  errorNameClient: "Nome do cliente é obrigatório",
  errorCellPhone: "Telefone do cliente é obrigatório",
};

const KEYS = {
  nameClient: "nome",
  cellPhone: "telefone",
};

function CashbackUpdateClient({ id, name, cellPhone }) {
  const [wait, setWait] = useToggle(false);
  const dispatch = useDispatch();
  const schema = [
    {
      type: "text",
      label: STR.labelNameClient,
      name: KEYS.nameClient,
      placeholder: STR.placeholderNameClient,
      defaultValue: name,
    },
    {
      type: "text",
      label: STR.labelCellPhone,
      name: KEYS.cellPhone,
      placeholder: STR.placeholderCellPhone,
      defaultValue: cellPhone,
      mask: [/\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/],
    },
  ];
  const schemaMessageError = {
    [KEYS.nameClient]: STR.errorNameClient,
    [KEYS.cellPhone]: STR.errorCellPhone,
  };
  const schemaValidator = yup.object().shape({
    [KEYS.nameClient]: yup.string().required(),
    [KEYS.cellPhone]: yup
      .string()
      .matches(/^\d{11}$/)
      .required(),
  });
  //
  const onSubmit = useCallback(
    (val) => {
      const obj = {
        id,
        [KEYS.nameClient]: val[KEYS.nameClient],
        [KEYS.cellPhone]: val[KEYS.cellPhone],
      };
      dispatch(cashbackEditClient(obj, setWait));
    },
    [dispatch, id, setWait]
  );

  return (
    <Stack>
      <H6>{STR.title}</H6>
      <Body1>{STR.subtitle}</Body1>
      <EntradaForm
        schema={schema}
        schemaMessageError={schemaMessageError}
        schemaValidator={schemaValidator}
        onSubmit={onSubmit}
        wait={wait}
      />
    </Stack>
  );
}

export default CashbackUpdateClient;
